<template>
    <div class="cc-quantity cc-quantity">
        <div @click="decreaseQuantity()" class="cc-quantity__control cc-quantity__control--minus">&minus;</div>
        <input
            @change="setQuantity"
            :step="changeStep"
            :disabled="this.config.theme_settings.disable_quantity_input"
            :placeholder="this.placeholder"
            :min="this.min"
            type="text"
            name="quantity"
            class="cc-quantity__input"
        />
        <div @click="increaseQuantity()" class="cc-quantity__control cc-quantity__control--plus">&plus;</div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
          ...mapState({
            config: state => state.config,
          }),
          placeholder: function () {
            let cartQuantity = this.product.cart_quantity;
            if (this.precision) {
              cartQuantity = parseFloat(cartQuantity).toFixed(this.precision);
            }
            if (this.product.id_category_default in this.config.theme_settings.custom_unit_by_category) {
              return cartQuantity + ' ' + this.config.theme_settings.custom_unit_by_category[this.product.id_category_default]['unit'];
            }
            if (this.config.theme_settings.custom_unit_by_category[0] !== undefined) {
              return cartQuantity + ' ' + this.config.theme_settings.custom_unit_by_category[0]['unit'];
            }
            return cartQuantity;
          },
          changeStep: function () {
            if (this.product.id_category_default in this.config.theme_settings.custom_unit_by_category) {
              return this.config.theme_settings.custom_unit_by_category[this.product.id_category_default]['step'];
            }
            if (this.config.theme_settings.custom_unit_by_category[0] !== undefined) {
              return this.config.theme_settings.custom_unit_by_category[0]['step'];
            }
            return 1;
          },
          min: function () {
            if (this.product.id_category_default in this.config.theme_settings.custom_unit_by_category) {
              return this.config.theme_settings.custom_unit_by_category[this.product.id_category_default]['minValue'];
            }
            if (this.config.theme_settings.custom_unit_by_category[0] !== undefined) {
              return this.config.theme_settings.custom_unit_by_category[0]['minValue'];
            }
            return 1;
          },
          precision: function () {
            if (this.product.id_category_default in this.config.theme_settings.custom_unit_by_category) {
              return this.config.theme_settings.custom_unit_by_category[this.product.id_category_default]['precision'];
            }
            if (this.config.theme_settings.custom_unit_by_category[0] !== undefined) {
              return this.config.theme_settings.custom_unit_by_category[0]['precision'];
            }
            return 0;
          }
        },
        methods: {
            increaseQuantity: function () {
                this.$store.dispatch('products/INCREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute,
                    id_customization: this.product.id_customization,
                    quantity: this.changeStep,
                })
            },
            decreaseQuantity: function () {
                let quantity;
                if (this.changeStep === '') {
                  quantity = 1;
                } else {
                  quantity = this.changeStep;
                }

                if (this.product.cart_quantity - this.changeStep < this.min) {
                    quantity = this.product.cart_quantity - this.min;
                }
                if (quantity <= 0) {
                    return;
                }
                this.$store.dispatch('products/DECREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute,
                    id_customization: this.product.id_customization,
                    quantity: quantity,
                })
            },
            setQuantity: function (event) {
                let quantity = event.target.value.replace(',', '.');
                if (this.min && quantity < this.min) {
                    quantity = this.min;
                }
                this.$store.dispatch('products/SET_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute,
                    quantity: quantity,
                    id_customization: this.product.id_customization,
                    cart_quantity: this.product.cart_quantity,
                }).then(() => {
                    event.target.value = '';
                })
            },
        },
        props: [
            'product',
        ],
    };
</script>

<style lang="scss" scoped>
    @import "../scss/components/components/product-quantity.scss";
</style>
